import VueRouter from 'vue-router';
import Main from './pages/Main.vue';
import Order from './pages/order/Order.vue';
import Service from './pages/service/Service.vue';

export const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: Main,
        },
        {
            path: '/order',
            component: Order,
        },
        {   // Fix for wrong shortcut
            path: '/orde',
            redirect: '/order',
        },
        {
            path: '/service',
            component: Service,
        },
        {   // Fix for wrong shortcut
            path: '/servic',
            redirect: '/service',
        },
    ],
    mode: 'history',
});